import { request } from '../http/request'
import { API_BASE_URL } from './config'

class PromoBannerService {
  active() {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/promoBanner/active`, 'get')
        resolve(_result?.data?.data)
      } catch (error) {
        reject(error)
      }
    })
  }

  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/promoBanner/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  updateOrCreate(data) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/promoBanner/updateOrCreate`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  toggle(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/promoBanner/toggle/${id}`, 'post')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  delete(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/promoBanner/${id}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  getSettings() {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/promoBanner/settings`, 'get')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }

  updateSettings(data) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/promoBanner/settings`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
}

export const promoBanner = new PromoBannerService()
